import React from "react";
import QuantityUpdate from "../../items/quantity-update";

interface QuantitySelectorProps {
  quantity: number;
  setQuantity: (quantity: number) => void;
  maxQuantity?: number;
}

const QuantitySelector = ({ quantity, setQuantity, maxQuantity }: QuantitySelectorProps) => {
  return (
    <div className="flex w-full justify-between items-center bg-white md:bg-grey-fields-200 rounded-10 py-2.5 px-0 md:px-3">
      <dt className="text-sm text-dark font-medium">Quantity</dt>
      <QuantityUpdate
        value={quantity}
        onChange={(qty: number) => setQuantity(qty)}
        increment={() => setQuantity(quantity + 1)}
        decrement={() => setQuantity(quantity - 1)}
        deleteAction={() => setQuantity(0)}
        showDeleteAction={false}
      />
    </div>
  );
};

export default QuantitySelector;
